import { css } from 'emotion';

export const header = css(`
	width: 100%;
`);
